// Generated code, do not edit manually. Run the following command to regenerate it:
// > nx generate-icons packages/systems/plugins/Link

import {SVGProps, ReactElement, createElement} from 'react';
import type {IconProps} from '@packages/utilities/icon-support';
export default /*#__PURE__#*/ function Link(
  props: IconProps
): ReactElement<SVGProps<SVGElement>> {
  const inputScale = props.scale ?? 1;
  const scale =
    typeof inputScale === 'number' ? inputScale : parseInt(inputScale, 10);
  return createElement(
    'svg',
    {
      'data-icon': 'Link',
      'aria-hidden': true,
      focusable: false,
      width: 12 * scale,
      height: 12 * scale,
      viewBox: '0 0 12 12',
      y: props.y != null ? props.y : undefined,
      x: props.x != null ? props.x : undefined,
      className: 'bem-Svg' + (props.className ? ' ' + props.className : ''),
      style: {
        ...{
          display: 'block',
        },
        ...props.style,
      },
    },
    createElement('path', {
      d: 'M1.755 4.587l-.529.529a4 4 0 105.657 5.657l1.06-1.061a4 4 0 00-.374-5.988L6.132 5.161a2 2 0 01.397 3.137l-1.06 1.06a2 2 0 01-3.324-2.01 5.014 5.014 0 01-.39-2.76z',
      fill: 'currentColor',
    }),
    createElement('path', {
      d: 'M10.242 7.412l.528-.529a4 4 0 10-5.656-5.657l-1.061 1.06a4 4 0 00.376 5.99l1.436-1.437A2.004 2.004 0 015.468 3.7l1.06-1.06a2 2 0 013.324 2.01c.392.871.523 1.83.391 2.76z',
      fill: 'currentColor',
    })
  );
}
